<section class="section" id="jobs">
  <div class="container jobs">
    <div class="section-box">
      <div class="about-title mb-5" data-animate="slideInUp" data-animate-duration="1000">
        <h3 class="e-font section-title">
          <span class="code-font n-section-title">02.</span>
          {{ "Experience.Title" | translate }}
        </h3>
      </div>
      <div class="jobs-tabs" data-animate="fadeInUp" data-animate-duration="1200" data-animate-delay="300">
        <ul
          ngbNav
          #nav="ngbNav"
          [(activeId)]="active"
          orientation="vertical"
          class="nav-tabs jobs-tabs"
        >
          <li
            *ngFor="let job of 'Experience.Jobs' | translate; let i = index"
            [title]="job.Tab"
            [ngbNavItem]="i"
            data-animate="scaleIn"
            [attr.data-animate-delay]="600 + (i * 150)"
          >
            <a ngbNavLink>{{ job.Tab }}</a>
            <ng-template ngbNavContent>
              <h4 class="title-tab-content">
                {{ job.Title }} |
                <span class="company-tab-content">{{ job.Tab }}</span>
              </h4>
              <h5 class="job-time">{{ job.Date }}</h5>
              <!-- {{job.Description | json}} -->
          <div class="job-description-card">
            <p
                *ngFor="let jobDescriptionParagraph of job.Description; let i = index"
                 class="job-description"
                 [innerHTML]="jobDescriptionParagraph | translate"
                data-animate="fadeInLeft"
                [attr.data-animate-delay]="i * 200"
            ></p>
          </div>
                <!-- ✅ Keywords -->
              <!-- ✅ Keywords with label -->
             <div class="job-keywords">
              <span class="keywords-label">Keywords:</span>
              <span *ngFor="let kw of job.Keywords" class="keyword">{{ kw }}</span>
            </div>

              <span></span>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</section>
